import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 100% { opacity: 0.4; }
  50% { opacity: 0.8; }
`;

/**
 * The one skeleton placeholder shape. Compose these into a layout that mirrors
 * the real component so nothing jumps when the data lands — see "Loading &
 * Progress" in `docs/design-system.md`.
 *
 * No shimmer gradients, no staggered delays: every skeleton in the app pulses
 * on the same 1.5s curve so two loading surfaces never read as two systems.
 *
 * The fill is `--surface-elevated`, one step up from the app's dark surfaces.
 * A skeleton on a light surface (the white content editor) sets
 * `--skeleton-fill` on its container instead — the dark box on white would
 * read as content, not as a placeholder.
 */
const SkeletonBox = styled.div<{
  $width?: string;
  $height?: string;
  $radius?: string;
}>`
  background-color: var(--skeleton-fill, var(--surface-elevated));
  border-radius: ${props => props.$radius ?? '4px'};
  width: ${props => props.$width ?? '100%'};
  height: ${props => props.$height ?? '14px'};
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

export default SkeletonBox;
